export default class JSONFileHelper {

    public async getEntry(id: string): Promise<{}> {
        // Try using pls-manifest.dev.json or through URL params
        let contentID, contentProps;

        // Get content ID to run using pls-manifest.dev.json
        const isProd = process.env.NODE_ENV === "production";
        try {
                contentID = id;
                contentProps = require(`../../../../contentProps/${contentID}.props.json`);
                return contentProps;
            } catch (e) { // Get contentProps from props.json file
                // Insert type field into contentProps and set its value to contentID
                contentProps = { type: contentID };
                console.log(`ContentProps file with name ${contentID}.props.json not found.
        Currently, using ${contentProps} as contentProps`);
            }
        // Get contentProps from URL params
        return contentProps;
    }
}
